// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cpu","clipPath":"url(#clip0_543_1945)"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4 4H20V20H4V4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 9H15V15H9V9Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 8H1.5M8 4V1.5M16 4V1.5M20 16H22.5M20 8H22.5M8 20V22.5M16 20V22.5M4 16H1.5M4 4H20V20H4V4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 9H15V15H9V9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CpuIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'cpu',
    ref,
    icon: element,
  },
));

CpuIcon.displayName = 'CpuIcon';

export default CpuIcon;
